export const publicTimeline = async (token, max_id) => {
    const headers = { 'Authorization': 'Bearer ' + token }
    const fetch_url = max_id
        ? 'https://makegayfriends.com/api/v1/timelines/public?local=true&max_id=' + max_id
        : 'https://makegayfriends.com/api/v1/timelines/public?local=true'
    try {
        const response = await fetch(fetch_url, { headers })
        if (!response.ok) return []
        const data = await response.json()
        return Array.isArray(data) ? data : []
    } catch {
        return []
    }
}

// Mastodon's combined search — returns { accounts, statuses, hashtags } in one
// call, unlike /accounts/search (people only) used elsewhere for messaging.
export const search = async (query, token) => {
    const headers = { 'Authorization': 'Bearer ' + token }
    const fetch_url = 'https://makegayfriends.com/api/v2/search?q=' + encodeURIComponent(query) + '&resolve=false&limit=20'
    try {
        const response = await fetch(fetch_url, { headers })
        if (!response.ok) return { accounts: [], statuses: [], hashtags: [] }
        const data = await response.json()
        return {
            accounts: Array.isArray(data?.accounts) ? data.accounts : [],
            statuses: Array.isArray(data?.statuses) ? data.statuses : [],
            hashtags: Array.isArray(data?.hashtags) ? data.hashtags : [],
        }
    } catch {
        return { accounts: [], statuses: [], hashtags: [] }
    }
}

// Mastodon's /v2/search "statuses" are text-matched, not tag-matched — it
// doesn't reliably return a hashtag's actual posts even when queried as
// "#tag". The posts actually associated with a hashtag live on its own
// dedicated timeline.
export const hashtagTimeline = async (hashtag, token, max_id) => {
    const headers = { 'Authorization': 'Bearer ' + token }
    const base = 'https://makegayfriends.com/api/v1/timelines/tag/' + encodeURIComponent(hashtag)
    const fetch_url = max_id ? base + '?max_id=' + max_id : base
    try {
        const response = await fetch(fetch_url, { headers })
        if (!response.ok) return []
        const data = await response.json()
        return Array.isArray(data) ? data : []
    } catch {
        return []
    }
}
